/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AuditEventResponseSeverity = typeof AuditEventResponseSeverity[keyof typeof AuditEventResponseSeverity];


export const AuditEventResponseSeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;
